export default "__VITE_ASSET__d15dd2b4__"